import * as React from "react"
import { cn } from "../../lib/cn"

const Container = React.forwardRef(({ 
  className, 
  variant = "default",
  ...props 
}, ref) => {
  const variants = {
    default: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
    narrow: "max-w-4xl mx-auto px-4 sm:px-6 lg:px-8",
    wide: "max-w-full mx-auto  sm:px-6 lg:px-4",
    section: "max-w-7xl mx-auto  lg:px-8 py-12 md:py-16 lg:py-20",
    container: "max-w-7xl mx-auto  lg:px-8",
  }
  
  return (
    <div
      ref={ref}
      className={cn(variants[variant], className)}
      {...props}
    />
  )
})

Container.displayName = "Container"

export { Container }